const { default: styled } = require('styled-components');
const { Menu } = require('zui/Antd');

const MenuWhite = styled(Menu)`
	// Add your styles here
	.ant-menu {
		background-color: white !important;
	}
`;

export default MenuWhite;
